import { RootState } from 'src/redux-file/store';

export function selectEffectivePlatformPortal(state: RootState) {
  if (state.platform.isAuthenticated === true) {
    return (
      state.platform.platformSubscriber.portal ||
      state.platform.publicPlatformPortal
    );
  }

  return (
    state.platform.publicPlatformPortal
  );
}
